import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/empresas/puestos-de-comercio-informal/';

/**
 * GET Puestos de Comercios
 * @returns {Promise<Array<object>>}
 */
export const getPuestosDeComercios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Puesto de Comercio
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPuestoDeComercio = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Puesto de Comercio
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPuestoDeComercio = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Puesto de Comercio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPuestoDeComercio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Puesto de Comercio
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePuestoDeComercio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
